import Vue from 'vue'
import VueGtag from 'vue-gtag'
 
export default ({ app }) => {
  Vue.use(
    VueGtag,
    {
      config: {
        id: 'G-1V50N7R4LR',
        params: {
          anonymize_ip: true,
        },
      },
      // Google-Ads-Konto als zusätzliches Ziel, damit Conversion-Events
      // (send_to: 'AW-10985098189/...') sicher ankommen
      includes: [
        {
          id: 'AW-10985098189',
          params: {
            allow_enhanced_conversions: true,
          },
        },
      ],
      appName: 'Website',
      pageTrackerTemplate: (to, from) => to.fullPath,
      bootstrap: false,
      enabled: false,
    },
    app.router,
  )
}
 